import script from "./apply-school.vue?vue&type=script&setup=true&lang=js"
export * from "./apply-school.vue?vue&type=script&setup=true&lang=js"

import "./apply-school.vue?vue&type=style&index=0&id=6599d4d3&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6599d4d3"]])

export default __exports__